import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '@monorepo/widgets';

import { FooterContainerComponent } from './components/footer-container/footer-container.component';

@NgModule({
  declarations: [FooterContainerComponent],
  imports: [CommonModule, WidgetsModule],
  exports: [FooterContainerComponent],
})
export class FooterModule {}
